module.exports = __webpack_public_path__ + "static/img/name6.9e4b680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/name6.png
// module id = cYpM
// module chunks = 1